export default defineAppConfig({
  ui: {
    colors: {
      primary: 'ocean',
      secondary: 'slate',
      neutral: 'gray'
    },

    avatar: {
      slots: {
        root: 'bg-transparent'
      },
      variants: {
        size: { '2xl': { root: 'size-16' } }
      }
    },

    badge: {
      variants: {
        variant: {
          solid: 'dark:text-white'
        },
        color: {
          error: 'dark:bg-red-400',
          success: 'dark:bg-[#B4FEA9] dark:text-brand-800',
          neutral: 'ring-1 ring-neutral-700 dark:bg-neutral-800',
          secondary: 'ring-1 ring-neutral-700 dark:bg-neutral-900'
        }
      }
    },

    button: {
      slots: {
        base: 'transition'
      },
      variants: {
        variant: {
          solid: 'dark:text-white'
        },
        size: {
          lg: { base: 'py-2.5 px-4' }
        }
      },
      compoundVariants: [
        {
          color: 'neutral',
          variant: 'solid',
          class:
            'bg-neutral-800 ring-1 ring-neutral-700 text-neutral-200 hover:bg-neutral-700/50'
        },
        {
          color: 'info',
          variant: 'solid',
          class: 'bg-sky-400 hover:bg-sky-500'
        },
        {
          color: 'info',
          variant: 'outline',
          class: 'ring-sky-400 text-sky-400 hover:bg-sky-400/10'
        },
        {
          color: 'info',
          variant: 'ghost',
          class: 'text-sky-400 hover:bg-sky-950'
        }
      ]
    },

    card: {
      slots: {
        root: 'dark:bg-midnight-700'
      }
    },

    dropdownMenu: {
      slots: {
        content: 'dark:bg-midnight-700 dark:ring-midnight-600'
      }
    },

    tabs: {
      compoundVariants: [
        {
          color: 'primary',
          variant: 'pill',
          class: {
            indicator: 'bg-neutral-900',
            trigger: 'data-[state=active]:text-white'
          }
        }
      ]
    },

    table: {
      slots: {
        separator: 'bg-neutral-800',
        th: 'text-sm font-medium text-neutral-200 whitespace-nowrap py-2 px-1 first:pl-0 last:pr-0',
        td: 'text-sm py-3 px-2 first:px-0 last:px-0 text-white'
      }
    },

    selectMenu: {
      slots: {
        group: 'cursor-pointer',
        item: 'items-center! hover:bg-elevated',
        content: ['!w-(--reka-combobox-trigger-width)'],
        trailingIcon:
          'group-data-[state=open]:rotate-180 transition-transform duration-200'
      },
      variants: {
        size: {
          md: {
            base: 'py-2.5 px-3.5',
            itemTrailingIcon: 'size-4'
          }
        }
      }
    },

    tooltip: {
      slots: {
        content:
          '[@media(pointer:coarse)]:hidden px-2 py-1 text-xs h-auto font-normal relative overflow-auto text-wrap max-w-xs',
        text: 'overflow-auto text-wrap'
      }
    },

    input: {
      variants: {
        size: { lg: { base: 'py-2.5 px-3.5' } }
      },
      defaultVariants: {
        size: 'lg'
      }
    },

    navigationMenu: {
      slots: {
        linkLeadingIcon: 'size-4'
      },
      variants: {
        orientation: {
          vertical: {
            link: 'py-2.5 px-4 gap-2'
          }
        }
      },
      compoundVariants: [
        {
          active: true,
          orientation: 'vertical',
          class: {
            linkLeadingIcon: 'text-white',
            link: 'before:bg-brand-500 text-white'
          }
        },
        {
          active: true,
          highlight: true,
          orientation: 'horizontal',
          class: {
            link: 'text-white after:h-0.5'
          }
        }
      ]
    },

    popover: {
      slots: {
        content: 'dark:bg-midnight-700'
      }
    }
  }
})
